module.exports = __webpack_public_path__ + "static/img/4981_phase_function_Paper_PointsHejduk_Prediction.13c6fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4981_phase_function_Paper_PointsHejduk_Prediction.png
// module id = e8Qk
// module chunks = 0